import { useSelector } from 'react-redux';

export default () => {
  const theme = useSelector((state) => state.othersReducer.theme);
  return theme;
};
